import {Component, OnInit} from '@angular/core';
import {ToastMessagesService} from '../../../../services/toast-messages.service';
import {ResumeService} from '../../../../services/resume.service';

@Component({
  selector: 'app-resumes-questions',
  templateUrl: './resumes-questions.component.html',
  styleUrls: ['./resumes-questions.component.scss']
})
export class ResumesQuestionsComponent implements OnInit {
  questions: any[] = [];
  displayedQuestion: any[] = [];
  constructor(public toastService: ToastMessagesService,
              private resumeService: ResumeService) {
  }

  async ngOnInit(): Promise<void> {
    await this.fetchQuestions();
  }

  async fetchQuestions() {
    try {
      const questions = await this.resumeService.fetchQuestions();
      console.log(questions);
      this.questions = [...questions];
      this.displayedQuestion = [...questions];
    } catch (e) {
      this.toastService.toastErrorMessage(e.message);
    }
  }

  createNewResumeField() {

  }
}
